import canClockShiftEntry from '@/mixins/clocking/individual/canClockShiftEntry';
import constants from '@/constants';

export default {
  mixins: [canClockShiftEntry],

  methods: {
    createShiftClockOut(
      shiftTimePair,
      assignmentId,
      successCallBack,
      lastly = () => {},
      timeZoneOffset = null,
      locationRequired = false,
    ) {
      this.getBaseTimeEntryRequest(
        constants.EntryType.CLOCK_OUT,
        timeZoneOffset,
        locationRequired,
        assignmentId,
        null,
        (timeEntryRequest) => {
          timeEntryRequest.shiftTimePairId = shiftTimePair.id;

          this.postShiftTimeEntry(timeEntryRequest, successCallBack, lastly);
        },
        lastly,
      );
    },
  },
};
